import { PageTable, Header } from "/src/layouts/page";
import Tabs from "/src/components/UI/Tabs/Tabs";
import CriteriaAdminPage from "/src/features/administration/criteria/components/CriteriaAdminPage/CriteriaAdminPage";
import UnitTable from "/src/features/administration/units/components/UnitTable/UnitTable";
import RoleTable from "/src/features/administration/roles/components/RoleTable/RoleTable";
import PoleTable from "/src/features/administration/poles/components/PoleTable/PoleTable";
import storage from "/src/utils/storage";
import hasPermission from "/src/utils/hasPermission";

function ConfigurationPanelPage() {
    const isAdmin = !!storage("local").get("user")?.is_admin;

    const tabs = [
        (isAdmin || hasPermission('view_criteria')) && { key: "criteria", label: "Criteria", icon: "fas fa-list-check", content: <CriteriaAdminPage /> },
        (isAdmin || hasPermission('view_units')) && { key: "units", label: "Units", icon: "fas fa-layer-group", content: <UnitTable /> },
        (isAdmin || hasPermission('view_roles')) && { key: "roles", label: "Roles", icon: "fas fa-user-shield", content: <RoleTable /> },
        (isAdmin || hasPermission('view_poles')) && { key: "poles", label: "Poles", icon: "fas fa-sitemap", content: <PoleTable /> },
    ].filter(Boolean);

    return (
        <PageTable>
            <Header title="Configuration Panel"></Header>
            <Tabs tabs={tabs} />
        </PageTable>
    );
}

export default ConfigurationPanelPage;
